import { Colors } from '@ab-core/colors';
import { SPACING } from '@ab-core/spacing';
import styled from 'styled-components';

export const StripContainer = styled.div`
    display: flex;
    align-items: stretch;
    background: transparent;
`;

export const MinimizeButton = styled.button`
    display: flex;
    align-items: center;
    justify-content: center;
    width: ${SPACING.MEDIUM};
    padding: 0;
    background: ${Colors.backgroundShade};
    border: none;
    border-top: 1px solid ${Colors.gray30};
    border-right: 1px solid ${Colors.gray30};
    border-bottom: 1px solid ${Colors.gray30};
    color: ${Colors.gray70};
    cursor: pointer;

    &:hover {
        color: ${Colors.black};
        background: ${Colors.white};
    }

    &:focus-visible {
        outline: 2px solid ${Colors.primary};
        outline-offset: -2px;
    }
`;

export const Tab = styled.button`
    appearance: none;
    display: inline-flex;
    align-items: center;
    background: ${Colors.backgroundShade};
    color: ${Colors.gray70};
    border: none;
    border-top: 1px solid ${Colors.gray30};
    border-right: 1px solid ${Colors.gray30};
    border-bottom: 1px solid ${Colors.gray30};
    padding: ${SPACING.SMALL} ${SPACING.SMALL_4};
    cursor: pointer;
    white-space: nowrap;
    line-height: 1.2;

    &:hover {
        color: ${Colors.black};
    }
    &.ab-crosselling-tab-is-active {
        position: relative;
        z-index: 1;
        margin-bottom: -1px;
        background: ${Colors.white};
        color: ${Colors.black};
        border-bottom-color: transparent;
    }

    &:focus-visible {
        outline: 2px solid ${Colors.primary};
        outline-offset: -2px;
    }
`;
